import { ChevronRightDetail, EditPenIcon, TrashDeleteIcon } from "../asset";
import { REGEX_CONSTANT } from "../constant/regexConstant";
import { ROUTES } from "../constant/routeConstant";

export const initialSort = {
  sortDateModified: 'asc',
  sortName: 'asc',
  sortEmail: 'asc',
}

export const column = (t, sortDateModified, sortName, sortEmail) => [
  {
    label: 'ID',
    field: 'id',
    sort: false,
  },
  {
    label: t('DATA_GROUP:TBL_DATA_GROUP_NAME'),
    field: 'data_group_name',
    sort: true,
    typeSort: sortDateModified,
  },
  {
    label: t('DATA_GROUP:TBL_DESCRIPTION'),
    field: 'description',
    sort: true,
    typeSort: sortName,
  },
  {
    label: t('COMMON:ACTION'),
    field: 'action',
    sort: false,
  },
];

export const rows = (list, navigate, handleOpenDelete) => {
  return (
    list &&
    list?.map((item, index) => ({
      key: index,
      id: item.id ? item.id : '-',
      data_group_name: item.data_group_name ? item.data_group_name : '-',
      description: item.description ? item.description : '-',
      action: (
        <div className='flex ml-[-20px]'>
          <img
            src={EditPenIcon}
            alt='edit-icon'
            className=' mr-1 cursor-pointer'
            onClick={() => navigate(ROUTES.DATA_GROUP.EDIT, {state: list[index]})}
          />
          <img
            src={TrashDeleteIcon}
            alt='delete-icon'
            className=' cursor-pointer mr-1'
            onClick={() => handleOpenDelete(list[index])}
          />
          <img
            src={ChevronRightDetail}
            alt='chevron-right-detail'
            className=' cursor-pointer'
            onClick={() => navigate(ROUTES.DATA_GROUP.DETAIL, {state: list[index]})}
          />
        </div>
      ),
    }))
  )
}

export const validateSubmit = (error) => {
  for (const key in error) {
    if (Object.hasOwnProperty.call(error, key)) {
      if (error[key]) return false;
    }
  }
  return true;
}

export const UOMConvertionCode = (data) => {
  if (data === "T") {
    return 'C'
  } else if(data === "L") {
    return 'Cm'
  } else if(data === "V"){
    return 'm^3'
  } else if(data === "W"){
    return 'Kg'
  } else {
    return '-'
  }
}

export const justNumberAllowed = (event) => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);

  // Allow only number input
  if (!REGEX_CONSTANT.JUST_NUMBER.test(keyValue)) {
      event.preventDefault();
  }
}

export const disabledCategoryCode = (data) => {
  if(data === "Cm" || data === "Kg" || data === "m^3" || data === "^0C"){
    return true;
  } else {
    return false;
  }
}

export const getImgName = (img_url) => {
  if (img_url) {
    const image = img_url.split('/');
    
    return image[image.length - 1]
  } else {
    return '-';
  }
}